export const COOKIE_POLICY_CONTENT = `
## 1. ¿Qué son las cookies?

Las cookies son pequeños archivos de texto que un sitio web almacena en tu dispositivo (ordenador, móvil, tablet) cuando lo visitas. Permiten recordar preferencias o recopilar información estadística.

También utilizamos tecnologías similares, como el almacenamiento local del navegador (localStorage), para recordar tus preferencias de consentimiento.

## 2. ¿Quién utiliza las cookies en este sitio?

| Concepto | Dato |
| --- | --- |
| Titular | Alejandro Serrano Notivoli |
| NIF | ES29133706C |
| Correo electrónico | soporte@alejandrosn.com |
| Sitio web | https://alejandrosn.com |

## 3. Tipos de cookies que utilizamos

### Cookies técnicas (necesarias)

Son imprescindibles para recordar tus preferencias de consentimiento. No requieren consentimiento previo.

| Nombre | Tipo | Finalidad | Duración |
| --- | --- | --- | --- |
| cookie-consent | localStorage | Recordar tu elección sobre cookies analíticas y de anuncios | Hasta que la borres manualmente |

Este sitio no utiliza cookies de sesión ni de autenticación, ya que no requiere registro de usuario.

### Cookies analíticas y de medición (opcionales)

Solo se activan si aceptas expresamente en el banner de cookies. Si eliges «Solo necesarias», Google puede recibir una señal técnica sin cookies (Consent Mode) para estimar conversiones de forma agregada. En ese caso no se usan cookies de analítica ni de anuncios.

| Nombre | Proveedor | Finalidad | Duración |
| --- | --- | --- | --- |
| _ga | Google Analytics | Distinguir usuarios únicos | 2 años |
| _ga_* | Google Analytics | Mantener estado de la sesión analítica | 2 años |
| _gcl_au | Google Ads | Medir clics y conversiones de anuncios | 90 días |

### Servicios de terceros

| Servicio | Tipo | Finalidad | Más información |
| --- | --- | --- | --- |
| Google Fonts | Recurso externo | Cargar tipografía Plus Jakarta Sans | [Política de Google](https://policies.google.com/privacy) |
| Substack | Recurso externo | Imágenes y enlaces del listado de la newsletter | [Política de Substack](https://substack.com/privacy) |
| Google Ads | Medición publicitaria | Atribuir llamadas, reservas, formularios y emails a la campaña, solo si aceptas cookies | [Política de Google](https://policies.google.com/privacy) |

## 4. Cómo gestionar tus preferencias

Al visitar AlejandroSN por primera vez, verás un banner con dos opciones:

- **Aceptar todas:** activa cookies analíticas (Google Analytics) y de medición de anuncios (Google Ads).
- **Solo necesarias:** solo almacenamiento técnico de preferencias. No se guardan cookies de analítica ni de anuncios.

Puedes cambiar tu decisión en cualquier momento borrando el almacenamiento local de tu navegador para este sitio y recargando la página. El banner volverá a mostrarse.

También puedes configurar tu navegador para bloquear o eliminar cookies.

## 5. Más información

Para cualquier consulta sobre el uso de cookies, escríbenos a soporte@alejandrosn.com.

Consulta también nuestra [Política de Privacidad](/politica-privacidad).
`;
